import { Box, Divider, Paper, Stack, Typography } from "@mui/material";

const money = (value) => `$${(Number(value) || 0).toFixed(2)}`;

const Line = ({ label, value, strong = false, color }) => (
  <Stack direction="row" justifyContent="space-between" spacing={1}>
    <Typography
      variant={strong ? "subtitle2" : "body2"}
      color={strong ? "text.primary" : "text.secondary"}
      fontWeight={strong ? 700 : 400}
    >
      {label}
    </Typography>
    <Typography
      variant={strong ? "subtitle2" : "body2"}
      fontWeight={strong ? 700 : 600}
      color={color}
    >
      {value}
    </Typography>
  </Stack>
);

const ChargesSummaryCard = ({ charges, primaryLabel, totalPaid, balanceDue }) => (
  <Box className="grid grid-cols-2 md:grid-cols-4 gap-4">
    <Paper variant="outlined" sx={{ p: 2 }}>
      <Typography variant="caption" color="text.secondary" fontWeight={600}>
        Total charges
      </Typography>
      <Stack spacing={0.75} sx={{ mt: 1 }}>
        <Line label={primaryLabel} value={money(charges.primaryCharge)} />
        <Line label="Service charge" value={money(charges.serviceCharge)} />
        <Line label="Extra charges" value={money(charges.extraCharges)} />
        <Divider />
        <Line label="Total" value={money(charges.total)} strong />
        {charges.discount > 0 && (
          <Line label="Discount" value={`-${money(charges.discount)}`} color="warning.main" />
        )}
        <Line label="Final amount" value={money(charges.finalAmount)} strong />
      </Stack>
    </Paper>
    <Paper variant="outlined" sx={{ p: 2 }}>
      <Typography variant="caption" color="text.secondary">
        Total paid (verified)
      </Typography>
      <Typography variant="h6" color="success.main">
        {money(totalPaid)}
      </Typography>
    </Paper>
    <Paper variant="outlined" sx={{ p: 2 }}>
      <Typography variant="caption" color="text.secondary">
        Balance due
      </Typography>
      <Typography variant="h6" color={balanceDue > 0 ? "warning.main" : "text.primary"}>
        {money(balanceDue)}
      </Typography>
    </Paper>
  </Box>
);

export default ChargesSummaryCard;
